export const clock = {
  // Allow overriding for tests
  now: () => {
    return performance.now();
  },
};
